import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-advisory-content-title',
  templateUrl: './advisory-content-title.component.html',
  styleUrls: ['./advisory-content-title.component.scss']
})
export class AdvisoryContentTitleComponent {
  @Input() title: string;
}
